import * as yup from 'yup';

export const getValidationSchema = () =>
  yup.object().shape({
    noticePeriod: yup.number().oneOf([15, 30, 45, 60]).nullable(),
    financeComments: yup.string().nullable(),
  });

export const initialValues = {
  noticePeriod: null,
  financeComments: undefined,
};

export const fields = Object.keys(
  initialValues
) as (keyof typeof initialValues)[];
